import { Features } from '../../../../../../../../frontend/libs/shared/src/lib/types/features';

// We now maintain the feature flags list in the new Angular codebase
// tslint:disable-next-line:no-empty-interface
export interface FeatureFlags extends Features {}

export default class FeaturesService {
  static $inject = ['$http'];

  // TODO: Switch to /aptitude/api/features as soon as that works.
  baseUrl = '/aptitude/feature/list';

  constructor(private $http) {
    'ngInject';
  }

  getFeatures(): ng.IPromise<FeatureFlags> {
    return this.$http.get(this.baseUrl, {
      intercept: true,
      cache: true,
    });
  }
}
